import { Tooltip } from "antd";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { s3ImageLink } from "@/utils/links";
import type { CreatorAvatarFrameType } from "./resolveCreatorAvatarFrameType";

export {
  resolveCreatorAvatarFrameType,
  type CreatorAvatarFrameType,
} from "./resolveCreatorAvatarFrameType";

export default function CreatorAvatarFrame({
  type,
  size,
}: {
  type: CreatorAvatarFrameType;
  size: 56 | 80;
}) {
  const src =
    type === "your-reinvite"
      ? `${s3ImageLink}reinvited-avatar-frame.png`
      : `${s3ImageLink}${type === "wishlist" ? "wishlist" : "aha-picks"}-${size}.png`;

  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      className="h-full w-full flex-shrink-0 object-cover"
    />
  );
}

export function CreatorAvatarTooltip({
  type,
  children,
}: {
  type: CreatorAvatarFrameType | null;
  children: ReactElement;
}) {
  const { t } = useTranslation();
  return (
    <Tooltip
      title={type ? (
        <div key={type}>
          <div className="font-semibold">
            {t(`components.creatorAvatarTooltip.titles.${type}`)}
          </div>
          <div>{t(`components.creatorAvatarTooltip.${type}`)}</div>
        </div>
      ) : undefined}
    >
      {children}
    </Tooltip>
  );
}
